import { ReactNode } from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { NotificationBanner } from "../NotificationBanner";
import { useRadixPointerEventsGuard } from "@/hooks/useRadixPointerEventsGuard";
import { useMediaProtection } from "@/hooks/useMediaProtection";
import { useAuth } from "@/contexts/AuthContext";

interface LayoutProps {
  children: ReactNode;
  /** When true, the first child is a fullscreen hero that should not have top padding */
  hasHero?: boolean;
}

export function Layout({ children, hasHero = false }: LayoutProps) {
  useRadixPointerEventsGuard();
  const { isStaff } = useAuth();
  // Staff need normal browser behaviour while managing content
  useMediaProtection(!isStaff());

  return (
    <div className="min-h-screen flex flex-col">
      <NotificationBanner />
      <Navbar />
      <main className={`flex-1 ${hasHero ? '' : 'pt-20'}`}>
        {children}
      </main>
      <Footer />
    </div>
  );
}
